import * as React from "react"
import calssnames from "classnames"
import "./floatingButton.scss"
import { Color } from "types/bootstrap"

interface FloatingButton {
	className?: string
	color: Color
	onClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void
}

const FloatingButton: React.FC<FloatingButton> = ({
	children,
	color,
	className = "",
	...props
}) => {
	return (
		<button
			className={calssnames(
				"floating-button btn",
				`btn-${color}`,
				className
			)}
			{...props}
		>
			{children}
		</button>
	)
}

export default FloatingButton
